import { render, staticRenderFns } from "./PublishersDetail.vue?vue&type=template&id=63b54652&lang=html&"
import script from "./PublishersDetail.vue?vue&type=script&lang=js&"
export * from "./PublishersDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports